<template>
  <div class="content">

    <GlossaryTable :character="'S'" />

  </div>
</template>

<script>
import GlossaryTable from '@/components/GlossaryTable.vue'

export default {
  name: 'glossary-s',
  components: {
    GlossaryTable
  },
  metaInfo: {
    title: 'Glossar S',
    meta: [
      {
        name: 'description',
        content: 'Eine Sammlung verschiedener Begriffe aus der Elektrotechnik.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'glossary' })
  }
}
</script>
